import * as React from 'react';
import { classes, style } from 'typestyle';
const Window = ({ children, className, header }) => {
    return (React.createElement("div", { className: classes('tds-window', windowStyle, className) },
        header,
        children));
};
export default Window;
export const windowBoxShadow = '0px 6px 40px rgba(0, 0, 0, 0.5), 0px 2px 20px rgba(0, 0, 0, 0.25);';
const windowStyle = style({
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: windowBoxShadow,
});
//# sourceMappingURL=Window.js.map